import { IconProps } from '@/types/icons';

function SourcesIcon(props: IconProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M16.5 13.26V15.96C16.5 19.56 15.06 21 11.46 21H8.04C4.44 21 3 19.56 3 15.96V12.54C3 8.94 4.44 7.5 8.04 7.5H10.74"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 13.5H13.5C11.25 13.5 10.5 12.75 10.5 10.5V7.5L16.5 13.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 3H15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 5.25C7.5 4.5 8.57295 3 9.90214 3H12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 9V14.1583C21 15.45 19.5 16.5 18.75 16.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 9H18C15.75 9 15 8.25 15 6V3L21 9Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SourcesIcon;
